function handleEmptyTableResponse({
  clearStateSetters = [],
  onDataLoaded,
  onSummaryChange,
  setDataLoaded,
}) {
  clearStateSetters.forEach((clearState) => clearState([]));

  if (onSummaryChange) {
    onSummaryChange({ total: 0 });
  }

  if (setDataLoaded) {
    setDataLoaded(true);
  }

  if (onDataLoaded) {
    onDataLoaded();
  }
}

export default handleEmptyTableResponse;
